import { PageHeaderProvider } from '@/context/PageHeadingContext';
import React, { cloneElement, useEffect } from 'react';
import PageHeading from './PageHeading';
import { InfoMessage } from '@/features/infoMessage/infoMessage';

const APP_TITLE = 'Mitt Mälarenergi';

interface PageProps {
  route?: any;
  children: React.ReactElement<any>;
}

const PageMeta = ({ route }: Pick<PageProps, 'route'>) => {
  useEffect(() => {
    if (route?.path === '*') {
      document.title = `404 sida | ${APP_TITLE}`;
    } else {
      document.title = APP_TITLE;
    }
  }, [route?.path]);

  return null;
};

const Page = ({ ...props }: PageProps) => {
  const route = props.route;

  const initialValue = route
    ? {
        title: route.title,
        ...(route?.pageHeaderOptions || {}),
      }
    : {};

  return (
    <>
      <InfoMessage />
      <PageHeaderProvider initialValue={initialValue}>
        <PageMeta route={route} />
        <PageHeading />
        {cloneElement(props.children)}
      </PageHeaderProvider>
    </>
  );
};

export default Page;
